import { useQuery } from '@tanstack/react-query';
import React, { useEffect, useRef } from 'react';
import { NavLink, useNavigate } from 'react-router-dom';
import axios from '../../api/axios';
import { destroySession } from '../../helpers/Session';

const ReportPayperiods = () => {
    const navigate = useNavigate();

    const timeoutRef = useRef(null);

    const accesstoken = sessionStorage.getItem('accesstoken');
    const selectedDepartment = sessionStorage.getItem('reportsDepartment');
    const selectedDepartmentSlug = sessionStorage.getItem('reportsDepartmentSlug');
    const selectedYear = sessionStorage.getItem('reportsYear');

    const { data: payperiods, isLoading: isLoadingPayperiods, error: errorPayperiods } = useQuery({
        queryKey: ['payperiodlists', selectedYear],
        queryFn: async () => {
            const res = await axios.get(`payperiods/years/${selectedYear}`, {
                headers: { 'Authorization': `Bearer ${accesstoken}` }
            });
            return res.data.response;
        },
        enabled: !!selectedYear && !!accesstoken,
        retry: 1
    });

    useEffect(() => {
        if (errorPayperiods) {
            if (errorPayperiods.response?.data.status === 'inactive') {
                destroySession();
                clearTimeout(timeoutRef.current);
                timeoutRef.current = setTimeout(() => { navigate('/error'); }, 1000);
            }
        }
    }, [errorPayperiods]);

    const handleSetReportsPayperiodData = (id, payperiod) => {
        sessionStorage.setItem('reportsPayperiod', payperiod);
        sessionStorage.setItem('reportsPayperiodId', id);
    }

    return (
        <div className='payperiods'>
            <div className="page-header">
                <div className='title'>
                    <h1>Reports</h1>
                    <ul className='breadcrumbs'>
                        <li><NavLink to='/reports'>Reports</NavLink></li>
                        <li><NavLink to={`/reports/${selectedDepartmentSlug}`}>{selectedDepartment}</NavLink></li>
                        <li><span>{selectedYear}</span></li>
                    </ul>
                </div>
            </div>

            <div className='panels'>
                <div className='panel'>
                    <div className='content'>
                        <div className={`card ${isLoadingPayperiods && ' loading'}`}>
                            {
                                isLoadingPayperiods ? (
                                    [...Array(8)].map((_, i) => (
                                        <div key={i} className="card-content">
                                            <a>
                                                <i className="fa fa-folder"></i>
                                                <span>Resty Alejo</span>
                                            </a>
                                        </div>
                                    ))
                                ) : (
                                    payperiods?.map((item) => (
                                        <div key={item.id} className="card-content">
                                            <NavLink to={`/reports/${selectedDepartmentSlug}/${selectedYear}/${item.id}`} title={item.payperiod} onClick={() => { handleSetReportsPayperiodData(item.id, item.sdate + ' - ' + item.edate); }}>
                                                <i className="fa fa-folder"></i>
                                                <span>{item.sdate + ' - ' + item.edate}</span>
                                            </NavLink>
                                        </div>
                                    ))
                                )
                            }
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default ReportPayperiods;